// export const FETCH_BIBLIOS = 'FETCH_BIBLIOS';
export const FETCH_PUBLICATIONS = 'FETCH_PUBLICATIONS';
export const FETCH_BLOGS = 'FETCH_BLOGS'; 
export const FETCH_RESOURCES = 'FETCH_RESOURCES';
export const FETCH_HAZARDNOTES = 'FETCH_HAZARDNOTES'; 
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_FIRE_AUSTRALIA = 'FETCH_FIRE_AUSTRALIA';
export const SET_SHOW_SUBSEARCH = 'SET_SHOW_SUBSEARCH';
export const FETCH_RESEARCHBRIEFINGS = 'FETCH_RESEARCHBRIEFINGS';